import { render, staticRenderFns } from "./recovery.vue?vue&type=template&id=7fcd7e8b&scoped=true&"
import script from "./recovery.vue?vue&type=script&lang=ts&"
export * from "./recovery.vue?vue&type=script&lang=ts&"
import style0 from "./recovery.vue?vue&type=style&index=0&id=7fcd7e8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcd7e8b",
  null
  
)

export default component.exports